import type { TIrrigationDeviceStatus } from 'App/Map/types'

export const getAnyEmitterStatus = (statuses: TIrrigationDeviceStatus[]): TIrrigationDeviceStatus => {
  if (statuses.includes('on')) return 'on'

  if (statuses.includes('error')) return 'error'

  if (statuses.includes('off')) return 'off'

  return 'unknown'
}
